import React from 'react';
import Image from 'next/image';
import upArrowNext from '../../svgs/up_arrow_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function UpArrowNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={upArrowNext}
      alt={alt ?? 'Op'}
    />
  );
}
